import { useRef, useState } from 'react';

import { t } from 'i18next';

import { Icon, Loading } from '../UI';

import { WrapperMarketWidgetProps } from './types';
import { useThemeContext } from '../../context/Theme';
import { useSnapshot } from '../../hooks/useSnaphot';

export const WrapperMarketWidget = ({
  className = '',
  children,
  colSpan = 1,
  footer,
  title,
  titleIcon,
  width,
  lastUpdateDate,
}: WrapperMarketWidgetProps) => {
  const widgetRef = useRef(null);
  const { theme } = useThemeContext();
  const { snapshot, loading: snapshotLoading } = useSnapshot(widgetRef);

  const [lastWidgetUpdateAt, setLastWidgetUpdateAt] = useState<
    Date | undefined
  >(lastUpdateDate);

  return (
    <div
      className={`
      ${className}
      w-full
      h-120
      flex
      flex-col
      col-span-${colSpan}
      react-grid-item
      border
      border-grey-30
      rounded-xl
      shadow-md
    `}
      ref={widgetRef}
    >
      {/* HEADER */}
      <div
        className={`
        flex
        flex-shrink-0
        items-center
        justify-between
        w-full
        border-b
        border-grey-10
        dark:border-grey-70
        p-3.5
      `}
      >
        <div className="flex items-center">
          {titleIcon}
          <span className="text-sm font-semibold uppercase ml-1">{title}</span>
        </div>
        <div className={'flex hidden-from-snapshot'}>
          {snapshotLoading ? (
            <Loading className="mr-3" size="small" status />
          ) : (
            <Icon
              className="cursor-pointer mr-4 w-3 "
              color="black"
              svgName={'camera'}
              onClick={() => {
                const fileName =
                  'Widget-' +
                  (title || '').replace(/[^a-z0-9]/gi, '') +
                  '-' +
                  new Date().toISOString();
                snapshot(width, 1, fileName, theme, true);
              }}
            />
          )}
        </div>
      </div>

      {/* BODY */}
      <div className={`w-full h-full flex flex-col overflow-y-scroll`}>
        {children}
      </div>

      {/* FOOTER */}
      <div
        className={`
          flex
          flex-shrink-0
          items-center
          justify-between
          w-full
          h-12
          border-t
          border-grey-10
          dark:border-grey-70
          px-3.5
        `}
      >
        <div className="flex-none text-sm w-1/3 italic text-grey-50">
          {t('widget.lastUpdate')}
          <span className={'text-xs text-gray-30 ml-1'}>
            {lastWidgetUpdateAt && lastWidgetUpdateAt.toLocaleTimeString()}
          </span>
        </div>
        {footer}
      </div>
    </div>
  );
};
